export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SET_SEARCH_PARAM = 'SET_SEARCH_PARAM';
export const SET_OPTION_CODE_LIST = 'SET_OPTION_CODE_LIST';
export const SET_MODAL_VALUE = 'SET_MODAL_VALUE';
export const SET_DETAIL_VALUE = 'SET_DETAIL_VALUE';
export const ADD_IMAGE_FILE = 'ADD_IMAGE_FILE';

export default {
	DEFAULT_ASSIGN,
	SET_SEARCH_PARAM,
	SET_OPTION_CODE_LIST,
	SET_MODAL_VALUE,
	SET_DETAIL_VALUE,
	ADD_IMAGE_FILE
};
